import {Component, HostBinding, Input, OnInit, Renderer2} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {openCloseAnimation, rotateAnimation} from './menu-item.animations';
import { Util } from '@/utils/util';
import {
    trigger,
    state,
    style,
    transition,
    animate
  } from '@angular/animations';
@Component({
    selector: 'app-menu-item',
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.scss'],
    animations: [
        trigger('rotateIcon', [
          state('collapsed', style({ transform: 'rotate(0deg)' })),
          state('expanded', style({ transform: 'rotate(180deg)' })),
          transition('collapsed <=> expanded', animate('200ms ease-out')),
        ]),
        trigger('expandCollapse', [
          state('collapsed', style({ height: '0px', overflow: 'hidden' })),
          state('expanded', style({ height: '*', overflow: 'hidden' })),
          transition('collapsed <=> expanded', animate('300ms ease')),
        ])
      ]
})
export class MenuItemComponent implements OnInit {

    @Input() menuItem: any = null;
    public isExpandable: boolean = false;
    @HostBinding('class.nav-item') isNavItem: boolean = true;
    @HostBinding('class.menu-open') isMenuExtended: boolean = false;
    public isMainActive: boolean = false;
    public isOneOfChildrenActive: boolean = false;

    constructor(private router: Router,private renderer: Renderer2, private util:Util) {
    }

    ngOnInit(): void {
        if (this.menuItem && this.menuItem.children && this.menuItem.children.length > 0 ) {
            this.isExpandable = true;
        }
        this.calculateIsActive(this.router.url);
        this.router.events.pipe(filter((event) => 
            event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
                this.calculateIsActive(event.url);
        });
        this.autoOcultarMenu();
    }

    public autoOcultarMenu(){
        this.util.autoOcultarMenu(this.renderer);
    }

    public handleMainMenuAction() {
        if (this.isExpandable) {
            this.toggleMenu();
            return;
        }
        this.router.navigate(this.menuItem.path);
    }

    public toggleMenu() {
        this.isMenuExtended = !this.isMenuExtended;
    }

    public calculateIsActive(url: string) {
        this.isMainActive = false;
        this.isOneOfChildrenActive = false;
        if (this.isExpandable) {
            this.menuItem.children.forEach((item) => {
                if (item.path[0] === url) {
                    this.isOneOfChildrenActive = true;
                    this.isMenuExtended = true;
                }
            });
        } else if (this.menuItem.path[0] === url) {
            this.isMainActive = true;
        }
        if (!this.isMainActive && !this.isOneOfChildrenActive) {
            this.isMenuExtended = false;
        }
    }
    
}
